import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';

const PaymentStatus = () => {
    const [searchParams] = useSearchParams();
    const transactionId = searchParams.get('id');
    const [status, setStatus] = useState('PENDING');
    const [message, setMessage] = useState('Verifying payment status...');

    useEffect(() => {
        if (transactionId) {
            checkStatus();
        } else {
            setStatus('FAILED');
            setMessage('Invalid Request');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transactionId]);

    const checkStatus = async () => {
        try {
            const response = await axios.post('http://localhost:5000/api/status', { transactionId });
            if (response.data.success && response.data.data.success) {
                setStatus('SUCCESS');
                setMessage('Your payment was successful!');
            } else {
                setStatus('FAILED');
                setMessage('Payment failed or was cancelled.');
            }
        } catch (error) {
            setStatus('FAILED');
            setMessage('Error verifying payment status.');
        }
    };

    return (
        <section className="contact-page pad-tb bg-gradient5" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 text-center">
                        <div className="contact-form-card" style={{ background: '#fff', padding: '40px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                            {status === 'PENDING' && (
                                <div>
                                    <i className="fas fa-spinner fa-spin fa-4x text-primary mb-3"></i>
                                    <h3 style={{ marginTop: '20px' }}>{message}</h3>
                                </div>
                            )}
                            {status === 'SUCCESS' && (
                                <div>
                                    <i className="fas fa-check-circle fa-4x text-success mb-3"></i>
                                    <h3 style={{ marginTop: '20px', color: '#28a745' }}>{message}</h3>
                                    <p style={{ marginTop: '10px' }}>Transaction ID: {transactionId}</p>
                                    <Link to="/" className="btn-main bg-btn mt-4">Go to Home <span className="circle"></span></Link>
                                </div>
                            )}
                            {status === 'FAILED' && (
                                <div>
                                    <i className="fas fa-times-circle fa-4x text-danger mb-3"></i>
                                    <h3 style={{ marginTop: '20px', color: '#dc3545' }}>{message}</h3>
                                    <p style={{ marginTop: '10px' }}>Please try again or contact support.</p>
                                    <Link to="/phonepe-payment" className="btn-main bg-btn mt-4">Try Again <span className="circle"></span></Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PaymentStatus;
